/* eslint-disable max-lines */
import { get_token } from "@/router";

export default {
  props: {
    modalId: {
      type: String,
      default: 'membershipCardModal',
    },
  },
  data() {
    return ({
        membership_card: {},
        membership_card_qr: "",
        membership_card_loading: false,
        membership_card_error: "",
    })
  },
  methods: {
    is_authenticated() {
      return Boolean(get_token());
    },
    get_membershipcard() {
      this.membership_card_error = "";
      $(`#${this.modalId}`).modal('show');

      if (!this.is_authenticated()) {
        this.membership_card = null;
        this.membership_card_qr = "";
        this.membership_card_error = 'Please sign in to view your membership card.';
        return null;
      }

      return this.get_membership_card();
    },
    close_membership_card() {
      $(`#${this.modalId}`).modal('hide');
    },
  get_membership_card() {
    if (this.membership_card_loading) return null;

    this.membership_card_loading = true;
    this.membership_card_error = "";
    return $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/get_membership_card/`,
      method: 'POST',
      headers: {
        Authorization: `Token ${get_token()}`,
        'Content-Type': 'application/json',
      },
      success: (response) => this.handle_membership_card_success(response),
      error: (xhr) => {
        this.membership_card = null;
        this.membership_card_qr = "";
        this.membership_card_error = xhr.status === 401 || xhr.status === 403
          ? 'Your session has expired. Please sign in again to view your membership card.'
          : xhr.responseJSON?.message || 'Unable to retrieve your membership card.';
      },
      complete: () => {
        this.membership_card_loading = false;
      },
    });
  },
  handle_membership_card_success(response) {
    if (response?.status !== 'success' || !response?.data) {
      this.membership_card_error = response?.message || 'Unable to retrieve your membership card.';
      return;
    }
    this.membership_card = response.data;
    this.membership_card_qr = this.membership_card_qr_image(response.data.qr_code);
  },
  membership_card_qr_image(qr_code) {
    if (!qr_code) return "";
    return qr_code.startsWith('data:image') ? qr_code : `data:image/png;base64,${qr_code}`;
  },
  membership_card_name() {
    return this.membership_card?.membership?.membership_type?.name
      || '';
  },
  membership_card_valid_thru() {
    const date = new Date(this.membership_card?.valid_until);
    if (Number.isNaN(date.getTime())) return '-- / --';
    return `${String(date.getMonth() + 1).padStart(2, '0')} / ${String(date.getFullYear()).slice(-2)}`;
  },
  go_to_subscription (){
    $(`#${this.modalId}`).modal('hide');
    this.$router.push('/view_membership');
  }
  }
};


